import { LOCALE_ID, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { SafePipe } from './pipes/safe.pipe';
import { TimelineComponent } from './components/timeline/timeline.component';
import { CommonModule, registerLocaleData } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import localeHU from '@angular/common/locales/hu';
import { HeroCarouselComponent } from './components/hero-carousel/hero-carousel.component';
import { HeroComponent } from './components/hero/hero.component';
import { RouterModule } from '@angular/router';

registerLocaleData(localeHU);

@NgModule({
  imports: [CommonModule, TranslateModule, LocalizeRouterModule, MatTooltipModule, RouterModule],
  exports: [TranslateModule, LocalizeRouterModule, SafePipe, TimelineComponent, HeroCarouselComponent, HeroComponent],
  declarations: [SafePipe, TimelineComponent, HeroCarouselComponent, HeroComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'hu-HU' }],
})
export class SharedModule {}
